import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsTabSkeleton from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabSkeleton';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import { useI18n } from 'next-localization';
import useHelpers from 'hooks/helpers';
import { useFetchPortfolioSecuritiesTabDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import FundDetailsList from '../components/FundDetailsList';

const FundDetailsPortfolioSecuritiesTab = () => {
  const { t } = useI18n();
  const { getErrorDictionary } = useHelpers();
  const { shareClass, language, countryCode, correlationFundRangeId, site } = usePayload();
  const { data, error, isLoading } = useFetchPortfolioSecuritiesTabDataQuery(
    {
      shareClass,
      language,
      countryCode,
      correlationFundRangeId,
      site,
    },
    {
      skip: !shareClass,
    }
  );
  return (
    <FundDetailsTabRow className="mt-4">
      {isLoading ? (
        <FundDetailsTabSkeleton />
      ) : error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} />
      ) : data && data.content.portfolioSecurities.length !== 0 ? (
        <FundDetailsList data={data.content.portfolioSecurities} />
      ) : (
        <div className="body-default">{t('noResultsMessage')}</div>
      )}
    </FundDetailsTabRow>
  );
};

export default FundDetailsPortfolioSecuritiesTab;
